import { useEffect, useState } from "react";

// Debounce function
function debounce(func: any, wait: number, immediate?: boolean, ...rest) {
    let timeout: NodeJS.Timeout | null;
    return function () {
        const context = func,
            args = rest;
        const later = function () {
            timeout = null;
            if (!immediate) func.apply(context, args);
        };
        const callNow = immediate && !timeout;
        clearTimeout(timeout as NodeJS.Timeout);
        timeout = setTimeout(later, wait);
        if (callNow) func.apply(context, args);
    };
}

export default function useWindowSize() {
    function getSize() {
        return {
            width: window.innerWidth,
            height: window.innerHeight,
        };
    }

    const [windowSize, setWindowSize] = useState(getSize);

    useEffect(() => {
        // Debounce to avoid the function fire multiple times
        const handleResizeDebounced = debounce(function handleResize() {
            setWindowSize(getSize());
        }, 250);

        window.addEventListener("resize", handleResizeDebounced);
        return () => window.removeEventListener("resize", handleResizeDebounced);
    }, []);

    return windowSize;
}
